import Tone from 'tone';


export default () => {
  var motu = new Tone.UserMedia();
  // Find a way of exporting this
  const outputVolume = new Tone.Volume(-26);

  motu.open().then(function(){
    // const reverb = new Tone.Freeverb({ roomSize: .7, wet: .8});
    const EQ = new Tone.EQ3(-12, -1, -5);

    var comp = new Tone.Compressor({
      threshold: -20,
      ratio: 100
    });

    var autoPanner = new Tone.AutoPanner(.01).start();
    autoPanner.depth.value = .8;

    const vibrato = new Tone.Tremolo({
      frequency: '2m',
      depth: .8
    });

    const randomPitch = () => Math.round((Math.random() * 4) - 2);
    const pitch = new Tone.PitchShift(randomPitch());
    window.setInterval(() => pitch.set('pitch', randomPitch(), 10000), 1500);


    const stereo = new Tone.StereoWidener(.8);

    const feedbackDelay = new Tone.FeedbackDelay({
      delayTime: '4n',
      feedback: 0.6,
      wet: .4
    });

    new Tone.LFO({
      frequency: '2m',
      min: .4,
      max: 1,
      phase: Math.random() * 360
    }).connect(feedbackDelay.wet).start();
    new Tone.LFO({
      frequency: '3m',
      min: .2,
      max: .6,
      phase: Math.random() * 360
    }).connect(feedbackDelay.feedback).start();



    motu.chain(new Tone.Volume(22), comp, EQ, pitch, feedbackDelay, vibrato, autoPanner, stereo, outputVolume, Tone.Master);
  });

  return motu;
};



// WEBPACK FOOTER //
// ./src/microphone-input.js